/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms

import io.kvision.core.*
import io.kvision.html.Button
import io.kvision.html.Iframe
import io.kvision.html.Link
import io.kvision.html.footer
import io.kvision.modal.Modal
import io.kvision.modal.ModalSize
import io.kvision.utils.event
import io.kvision.utils.perc
import io.kvision.utils.px
import io.kvision.utils.vh

class PodgladWindow(token: String) : Modal(null, false, ModalSize.XLARGE, centered = true) {
  val iframe = Iframe().apply {
    width = 100.perc
    height = 80.vh
    border = Border(0.px, BorderStyle.NONE)
    background = Background(Color.name(Col.WHITE))
  }

  val closeModal: Button
  var printDocument: Link
  var wybranyButton: Button? = null

  init {
    add(iframe)
    closeModal = Button("Zamknij", "fas fa-check").onClick {
      this@PodgladWindow.hide()
    }
    printDocument = Link(
      "Drukuj",
      "/api/drukuj?doktoken=$token",
      "fas fa-print",
      target = "_blank",
      className = ("btn btn-primary mr-5")
    ).onClick {}
    printDocument.id = "btnPrint"
    footer.add(printDocument)
    addButton(closeModal)
    onEvent {
      event("shown.bs.modal") {
        closeModal.focus()
      }
      event("hidden.bs.modal") {
        wybranyButton?.focus()
      }
    }
  }

  fun pokazTresc(tresc: String, wybranyButton: Button) {
    this.wybranyButton = wybranyButton
    this.iframe.srcdoc = tresc
    this.show()
  }
}
